// extracted by mini-css-extract-plugin
export default {"unitselector":"DonatonPriceProperty_unitselector__AHj3D","equalsign":"DonatonPriceProperty_equalsign__WPScS","price":"DonatonPriceProperty_price__xDQMW"};